import React, {useState} from "react";
import styles from "../login/login.module.css";
import {PrimaryButton, TextInput} from "../../../components/input/inputs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import axiosInstance from "../../../AxiosInstance";
import {useTranslation} from "react-i18next";

export default function ForgotPassword() {
    const {t} = useTranslation();
    const [form, setForm] = useState({});
    const [showMessage, setShowMessage] = useState(false);
    const navigate = useNavigate();

    const back = () => {
        navigate('/login')
    }

    const handleSubmit = () => {
        if(Object.keys(form).length < 1) return;
        axiosInstance.post('forgot/', form);
        setShowMessage(true);
    }

    return (
        <div className={styles.container}>
            <div className={styles.background}>
                <img alt={'background'} src={'/login.png'} width={'100%'}/>
            </div>

            <div className={`${styles.loginContainer} px-4 pt-2`}>
                <div className={styles.innerContainer}>
                    <div className={'pt-4 pb-2'}>
                        <div className={'d-flex align-items-center mb-2'} role={'button'} onClick={back}>
                            <FontAwesomeIcon icon={faArrowLeft} color={'#64748B'} className={'pe-2'}/>
                            <div style={{fontWeight: "600", fontSize: "14px"}}>{t('auth.forgot.back')}</div>
                        </div>
                        <div className={styles.title}>{t('auth.forgot.title')}</div>
                        <div className={`${styles.description} mt-2`}>{t('auth.forgot.description')}</div>
                    </div>

                    {showMessage &&
                        <div className={`${styles.message} px-3 py-2`}>
                            <div>{t('auth.forgot.emailSentMsg')}</div>
                        </div>
                    }

                    <div className={'mt-3'}>
                        <TextInput name={'email'} form={form} setForm={setForm} placeholder={t('auth.forgot.emailPlaceholder')} hideName={true}/>
                    </div>

                    <div className={'mb-3'}>
                        <PrimaryButton name={t('auth.forgot.send')} onClick={handleSubmit}/>
                    </div>
                </div>
            </div>
        </div>
    );
}